import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReuseTabComponent } from './reuse-tab.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { TabMenuModule } from 'primeng/tabmenu';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    OverlayModule,
    TabMenuModule,
    TranslateModule.forChild({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      },
      isolate: false
  })
  ],
  declarations: [
    ReuseTabComponent,
  ],
  exports: [
    ReuseTabComponent,
    TranslateModule
  ],
})
export class AdReuseTabModule {
  static forRoot(): ModuleWithProviders<AdReuseTabModule> {
    return {
      ngModule: AdReuseTabModule,
    };
  }
}
